// ─────────────────────────────────────────────────────────────────────────────
// Automation Insights — Platform Constants
// Mirrors lib/platforms.ts in automationenablementopena-anedashboard (the
// standalone repo this page is being migrated from). Keep in sync with that
// file's PLATFORM_OPTIONS if the backend's PLATFORM_HIERARCHY changes.
// ─────────────────────────────────────────────────────────────────────────────

export interface AutomationPlatformOption {
  label: string;
  value: string;
}

export const AUTOMATION_PLATFORM_OPTIONS: AutomationPlatformOption[] = [
  { label: 'O&E APP', value: 'O&E_APP' },
  { label: 'O&E INT OCEAN', value: 'O&E_INT_OCEAN' },
  { label: 'O&E LNS', value: 'O&E_LNS' },
  { label: 'LANDSIDE EXECUTION', value: 'LANDSIDE EXECUTION' },
  { label: 'O&E CIRSC Execution', value: 'O&E CIRSC Execution' },
  { label: 'FAM', value: 'FAM' },
  // Split 2026-10 from the single combined "MCL/MEC/MGF" (query_key "FBM")
  // into three separate platforms — see PLATFORM_HIERARCHY in the backend's
  // automation/config/queries.py.
  { label: 'MCL', value: 'MCL' },
  { label: 'MEC', value: 'MEC' },
  { label: 'MGF', value: 'MGF' },
  { label: 'CLIC', value: 'CLIC' },
  { label: 'AIRLCL', value: 'AIRLCL' },
  { label: 'L0 SD', value: 'L0 SD' },
];

export const AUTOMATION_PLATFORM_OPTIONS_WITH_ALL: AutomationPlatformOption[] = [
  { label: 'All Platforms', value: 'all' },
  ...AUTOMATION_PLATFORM_OPTIONS,
];

export const DEFAULT_AUTOMATION_PLATFORM_VALUE = 'all';

/**
 * Reverse lookup: query_key -> display label. Used to render a human-readable
 * platform name from an API row's platform_key (Platform Summary table).
 */
export const PLATFORM_LABEL_BY_KEY: Record<string, string> = Object.fromEntries(
  AUTOMATION_PLATFORM_OPTIONS.map(({ label, value }) => [value, label])
);
